import React from 'react';
import PropTypes from 'prop-types';

import { CaretIcon } from './caret.styles';

const Caret = props => <CaretIcon name='caret_up' {...props} />;

Caret.defaultProps = {
  show: true,
};

Caret.propTypes = {
  show: PropTypes.bool,
};

export default Caret;
